import axiosInstance from '../utils/axios';
import API_CONFIG from '../config/api.config';

const printSettingsService = {
  /**
   * Get current print format settings
   * @returns {Promise} Print settings response
   */
  getPrintSettings: async (locationId = null) => {
    try {
      const response = await axiosInstance.get(API_CONFIG.ENDPOINTS.PRINT_SETTINGS, {
        params: { locationId }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching print settings:', error);
      throw error;
    }
  },

  /**
   * Update print format settings
   * @param {Object|string} settings - Settings object or printFormat string (legacy)
   * @param {string} locationId - Optional location ID
   * @returns {Promise} Update response
   */
  updatePrintSettings: async (settings, locationId = null) => {
    try {
      // Handle legacy call with just printFormat string
      const payload = typeof settings === 'string' 
        ? { printFormat: settings, locationId }
        : { ...settings, locationId };

      const response = await axiosInstance.put(
        API_CONFIG.ENDPOINTS.PRINT_SETTINGS,
        payload
      );
      return response.data;
    } catch (error) {
      console.error('Error updating print settings:', error);
      throw error;
    }
  },

  /**
   * Preview print format with sample data
   * @param {string} printFormat - 'A4', '3_INCH_SIMPLE', or '3_INCH_GST_DETAILS'
   * @returns {Promise<Blob>} PDF document as a Blob
   */
  previewPrintFormat: async (printFormat) => {
    try {
      const response = await axiosInstance.get(
        `${API_CONFIG.ENDPOINTS.PRINT_SETTINGS}/preview`,
        {
          params: { format: printFormat },
          responseType: 'blob'
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error generating preview:', error);
      throw error;
    }
  }
};

export default printSettingsService;

